<template>
  <div>
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="9"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Enrich Accounts To {{ campaignDescription.campaign_name }}</h3>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-button color="danger" @click="saveCsvMatchedAccount" type="border">Save</vs-button>

          <!-- <download-excel
            :data="records"
            :export-fields="json_fields"
            type="csv"
            name="unmatched.xls"
          >
            <vs-button icon="file_download" color="primary" type="filled">
              Export</vs-button
            >
          </download-excel> -->
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1"></div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="9"
          vs-sm="4"
          vs-xs="12"
        >
          <span>Search companies: </span>
          <AccountAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchCompany"
            :searchOn="'company_or_registration_no'"
            @event-name="handleChildEvent"
          ></AccountAutocomplete>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
      </vs-row>
      <vs-table class="mb-10" stripe :data="accounts">
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="company_registration_number">Registration No.</vs-th>
          <vs-th sort-key="company_name">Company Name</vs-th>
          <vs-th sort-key="company_name">Country</vs-th>
          <vs-th sort-key="registered_office_county">Registered Office</vs-th>
           <vs-th sort-key="revenue">Revenue</vs-th>
                      <vs-th sort-key="revenue">Employees</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].company_registration_number">
              {{ data[indextr].company_registration_number }}
            </vs-td>
            <vs-td :data="data[indextr].company_name">
              {{ data[indextr].company_name }}
            </vs-td>
             <vs-td :data="data[indextr].head_office_country">
              {{ data[indextr].head_office_country }}
            </vs-td>
            <vs-td :data="data[indextr].registered_office_address_1">
              {{ data[indextr].registered_office_address_1 }}
            </vs-td>
              <vs-td :data="data[indextr].revenue">
              {{ data[indextr].currency_name + ' ' + data[indextr].revenue }}
            </vs-td>
             <vs-td :data="data[indextr].no_of_employees">
              {{ data[indextr].no_of_employees }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-button @click="removeFromTable(data[indextr].id)"
                >Remove</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import JsonExcel from "vue-json-excel";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";

export default {
  components: {
    downloadExcel: JsonExcel,
    AccountAutocomplete
  },
  data() {
    return {
      companySearchComponentKey: 0,
      campaignDescription: [],
      accounts: [],
      json_fields: {
        Company: "ml_company",
        Country: "ml_country",
        Address: "ml_addresses"
      },
      campaignId: null,
      abilities: null
    };
  },
  computed: {},
  methods: {
    saveCsvMatchedAccount(){
      this.$router.replace("/accounts/enriched_account_contact_for_campaign/" + this.campaignId);
    },
    removeFromTable(account_id) {
      this.accounts = this.accounts.filter(function(ele) {
        return ele.id != account_id;
      });
    },
    handleChildEvent() {
      let result = moduleAccountsManagement.state.accounts.datas;
      this.accounts.push(result[0]);
      this.companySearchComponentKey += 1;
      console.log(this.accounts);
    },
    searchCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    }
    // getResult() {
    //   axios
    //     .post(this.$base_url + "/api/matched_accounts/matched_account", {
    //       campaignId: this.campaignId
    //     })
    //     .then(response => {
    //       this.records = JSON.parse(JSON.parse(JSON.stringify(response.data)));
    //       this.$vs.loading.close();
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // }
  },
  mounted() {
    // this.getResult();
    this.getCampaignDescription();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style>
.searchbox {
  margin-left: 5px;
  width: 600px;
}
</style>
